import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { User } from '../../model/user';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { CashSession } from '../../model/cashsession';
import { Session } from 'selenium-webdriver';
import { Flux } from '../../model/flux';
import { SettingService } from '../setting-service';
import { AuthService } from '../../../../auth/auth.service';



@Injectable()
export class CashSessionService {

  sessions: CashSession[];

  current:  CashSession;

  iSconnecting: boolean = false;

  // caisse: Compte;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              public settingService: SettingService,
              public authService: AuthService,
              ) { }

  getSessions(to: string, from: string, user: string, nature: string) {
    this.iSconnecting = true;
    return new Promise<CashSession[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_CASHSESSIONS(to, from, user, 'open', nature),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: CashSession[]) => {
            const sessions = plainToClass(CashSession, data);
            this.sessions = sessions;
            resolve(sessions);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  getSession( id: number) {
    this.iSconnecting = true;
    return new Promise<CashSession>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_CASHSESSION(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: CashSession) => {
            const session = plainToClass(CashSession, data as object);
            session.flux = plainToClass(Flux, session.flux);
            this.current = session;
            resolve(session);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }

  sessionClose(id: number) {

    this.iSconnecting = true;

    return new Promise<CashSession>(resolve => {
      this.http.get(this.apiEndpoints.URL_CLOSE_CASHSESSION(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: CashSession ) => {
            const session = plainToClass(CashSession, data as object);
            session.flux = plainToClass(Flux, session.flux);
            resolve(session);
            this.iSconnecting = false;
          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });

  }

  accountPartnerCash(typePartner: string) {

    this.iSconnecting = true;

    return new Promise<any[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_ACCOUNTPARTNER_CASH(typePartner),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: any[] ) => {
            resolve(data);
            this.iSconnecting = false;
          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });

  }

  /* getCurrent(id: number) {

    if (this.sessions !== undefined ) {

      for ( let i = 0; i < this.sessions.length; i++) {

        if (this.sessions[i].id ===  id ) {
          this.current = this.sessions[i];
          this.current.flux = plainToClass(Flux, this.current.flux);
        }
        // tslint:disable-next-line:no-console
        // console.log(this.factureService.factures[i].id);
      }

    }

  } */



  saveSession(session: CashSession) {

    this.iSconnecting = true;

    let id_partner: number;
      if (session.partenaire !== undefined && session.partenaire !== null) {
        id_partner = session.partenaire.id;
      } else {
        id_partner = null;
      }


   const sesiondata = {
      soldeInitial: session.solde_initial,
      nom: session.nom,
      nature: session.nature,
      description: session.description,
      partenaire: id_partner,
   };

    if (session.id !== 0) {

      return new Promise<CashSession>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PATCH_CASHSESSION(session.id), sesiondata,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: CashSession) => {

              const sessio = plainToClass(CashSession, data as object);
              sessio.flux = plainToClass(Flux, sessio.flux);

              let user: string;
              if (this.authService.isHavingPermission(['readCaisse'])) {
                user = '';
              } else {
                user = this.authService.token.user.id.toString();
              }

              // this.getSessions(this.settingService.toCaisse, this.settingService.fromCaisse, user);

              resolve(sessio);
              this.iSconnecting = false;


            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<CashSession>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_CASHSESSION, sesiondata,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: CashSession) => {

              const sessio = plainToClass(CashSession, data as object);
              sessio.flux = plainToClass(Flux, sessio.flux);

              let user: string;
              if (this.authService.isHavingPermission(['readCaisse'])) {
                user = '';
              } else {
                user = this.authService.token.user.id.toString();
              }

              // this.getSessions(this.settingService.toCaisse, this.settingService.fromCaisse, user);

              resolve(sessio);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }

  }

  deleteSession(id: number) {

    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_CASHSESSION(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            let user: string;

            if (this.authService.isHavingPermission(['readCaisse'])) {
              user = '';
            } else {
              user = this.authService.token.user.id.toString();
            }

            // this.getSessions(this.settingService.toCaisse, this.settingService.fromCaisse, user);

            resolve(data);
            this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }


}
